import { Box, type BoxProps, Flex } from "@chakra-ui/react";
import type { FC } from "react";
import { p } from ".";

type RangeProgressBarProps = {
  progress: number;
  exceededThreshold?: { below: number; above: number };
} & BoxProps;

export const RangeProgressBar: FC<RangeProgressBarProps> = ({
  progress,
  exceededThreshold = { below: 80, above: 100 },
  ...props
}) => {
  const width = 100;
  let body = 0,
    exceeded = 0;

  if (progress <= width) {
    // partial/full
    body = progress;
  } else {
    // exceeded
    body = (width / progress) * 100;
    exceeded = width - body;
  }

  return (
    <Box {...props}>
      <Flex
        overflow="hidden"
        h="10px"
        bg="grey.100"
        rounded="lg"
        style={{ width: p(width) }}
      >
        {!!body && (
          <Box
            bg={
              progress < exceededThreshold.below ||
              progress > exceededThreshold.above
                ? "red.500"
                : "teal.500"
            }
            style={{ width: p(body) }}
          />
        )}
        {!!exceeded && (
          <Box
            bg={`repeating-linear-gradient(-65deg, #FFB2B7, #DD3943 2px, #FFB2B7 4px )`}
            style={{ width: p(exceeded) }}
          />
        )}
      </Flex>
    </Box>
  );
};
